import React from "react";
import "../css/terms.scss";

function Terms() {
  return (
    <div className="terms-page">
      <div className="container">
        <h1>Terms of Service</h1>
        <div className="content-section">
          <p>
            These terms apply when you visit Cewillow Market or place an order.
            By using the website, you agree to these terms and the policies linked
            from the footer.
          </p>

          <div className="policy-block">
            <h2>Products and Availability</h2>
            <p>
              We aim to present product descriptions, colours, images and stock
              information accurately. Screen settings may affect colour appearance.
              We may correct genuine listing errors or cancel an unavailable item,
              in which case any amount paid for that item will be refunded.
            </p>
          </div>

          <div className="policy-block">
            <h2>Prices and Orders</h2>
            <p>
              Prices are shown in USD unless stated otherwise. Shipping is $9.99
              USD per order. An order is accepted only after payment is confirmed.
              We may decline an order for suspected fraud, payment failure,
              restricted destinations or clear pricing errors.
            </p>
          </div>

          <div className="policy-block">
            <h2>Payment</h2>
            <p>
              Payment is completed through our payment provider. Do not refresh or
              close the provider page while a transaction is processing. A success
              page confirms that the payment response was returned to our website;
              order fulfilment remains subject to final payment verification.
            </p>
          </div>

          <div className="policy-block">
            <h2>Shipping and Returns</h2>
            <p>
              Delivery estimates are not guarantees and may be affected by carrier,
              customs or address issues. Our Shipping and Returns & Exchanges pages
              form part of these terms.
            </p>
          </div>

          <div className="policy-block">
            <h2>Acceptable Use</h2>
            <p>
              You must not misuse the website, interfere with its operation, attempt
              unauthorised access, submit fraudulent orders or copy content in a way
              that infringes intellectual-property rights.
            </p>
          </div>

          <div className="policy-block">
            <h2>Intellectual Property</h2>
            <p>
              The Cewillow Market name, logo, original product photography, written
              content and website materials are protected to the extent permitted by
              law. Product and payment names may belong to their respective owners.
            </p>
          </div>

          <div className="policy-block">
            <h2>Liability</h2>
            <p>
              Nothing in these terms excludes rights that cannot lawfully be excluded.
              To the extent permitted by law, we are not liable for indirect or
              consequential loss arising from use of the website or delayed delivery.
            </p>
          </div>

          <div className="policy-block">
            <h2>Contact and Changes</h2>
            <p>
              Cewillow Market is operated by Hong Kong Mousheng Tech Limited,
              FLAT 1506, 15/F, CHEUNG FUNG COMM BLDG, 21-25 CHEUNG SHA WAN
              ROAD, SHAM SHUI PO, HONG KONG. Questions may be sent to{" "}
              <a href="mailto:import@cewillowmarket.life">import@cewillowmarket.life</a>.
              We may update these terms by posting a revised version on this page.
            </p>
            <p>Last updated: September 22, 2026.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Terms;
